import React from "react";
import { Grid, FormControlLabel, Checkbox } from "@mui/material";

export default function NotCostSetField({ disabled, value, onChange }) {
  const handleChange = (e) => {
    onChange({ cost_not_set: e.target.checked });
  };

  return (
    <Grid
      item
      xs={12}
      sm={7}
      sx={{
        paddingLeft: { sm: "20px" },
        paddingBottom: "20px",
      }}
    >
      <FormControlLabel
        label="金額設定がない要員も表示"
        control={<Checkbox checked={!!value} onChange={handleChange} />}
        disabled={disabled}
      />
    </Grid>
  );
}